import * as o from "react";
import r from "../lib/IconBase.es.js";
import a from "../defs/Empty.es.js";
const t = o.forwardRef((m, e) => /* @__PURE__ */ o.createElement(r, { ref: e, ...m, weights: a }));
t.displayName = "EmptyIcon";
const s = t;
export {
  s as Empty,
  t as EmptyIcon
};
